import React, { useState,useEffect,useRef } from 'react';

import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import parse from 'html-react-parser';
import QRCode from "react-qr-code";
import '../lib/bootstrap.min.css'
import './Main.css';
import './SubPage.css';

const Home = (props) => {
    const [title,setTitle] = useState()
    const [greeting,setGreeting] = useState()
    const [background,setBackground] = useState()
    const [wifiSSID,setWifiSSID] = useState()
    const [wifiPassword,setWifiPassword] = useState()
    
    function nl2br (str, replaceMode, isXhtml) {
        var breakTag = (isXhtml) ? '<br />' : '<br>';
        var replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
      }

    useEffect(()=>{

        if(props.profile){ 
            setTitle(props.profile.filter((_profile)=> _profile.object === 'title')[0].value)
            var greeting = props.profile.filter((_profile)=> _profile.object === 'greeting')[0].value
            if(props.reservation === null){
                greeting = greeting.replace("{room}",'No Room')
                greeting = greeting.replace("{guest}",'No Guest')
                setGreeting(greeting)
            }else{
                greeting = greeting.replace("{room}",props.reservation.room_name)
                if(props.reservation.reservation_active.length > 0){
                    greeting = greeting.replace("{guest}",props.reservation.reservation_active[0].guest_name)
                }else{
                    greeting = greeting.replace("{guest}",'No Guest')
                }
                setGreeting(greeting)
            }
            
            setWifiSSID(props.profile.filter((_profile)=> _profile.object === 'wifi_ssid')[0].value)
            setWifiPassword(props.profile.filter((_profile)=> _profile.object === 'wifi_password')[0].value)
        }
    })
    

  return (
    <AnimatePresence>
        <Row>
            <Col md={9}>
                <motion.div 
                    className='content-left'
                    initial={{ opacity: 0, marginLeft:-300 }}
                    animate={{ opacity: 1, marginLeft: 0,  }}
                    exit={{opacity:0, marginLeft: -300}}
                    transition={{ duration: 0.8, ease: [0.7, 0, 0.3, 1] }}
                >
                    <h2 style={{fontSize:40}}>{title},</h2>
                    {parse(
                        `<p style={{minHeight:90, maxHeight:117, overflow:'hidden'}}
                        > ${nl2br(greeting)} </p>`
                    )}
                    
                    <button className="btnHome" style={{float:'right'}} onClick={()=>{props.propertyInfo()}}>
                        Hotel Information &raquo;
                    </button>
                </motion.div>
            </Col>
            <Col md={3}>
                <motion.div className='content-right'
                    initial={{ opacity: 0, marginRight:-300 }}
                    animate={{ opacity: 1, marginRight: 0,  }}
                    exit={{opacity:0, marginRight:-300}}
                    transition={{ duration: 0.8, ease: [0.87, 0, 0.13, 1] }}>
                        <div style={{marginTop:'30px', textAlign: 'center', width:200, float:'right'}}>
                            &nbsp;
                            <p>Scan QR Code <br />to connect WIFI</p>
                            <QRCode 
                                value={"WIFI:S:"+ wifiSSID + ";T:WPA;P:" + wifiPassword + ";H:false;;"}
                                style={{
                                    background:'#ffffff',
                                    padding:5,
                                    marginBottom:15,
                                    width:90,
                                    height:90
                                }} />
                            <p>SSID : {wifiSSID}, <br />Password :{wifiPassword}</p>
                        </div>
                    
                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )};

export default Home;


